// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const CameraIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="icons" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><g id="camera" fill="currentColor" fillRule="nonzero"><path id="Shape" d="M2 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 16V4q0-.824.588-1.412A1.92 1.92 0 0 1 2 2h12q.825 0 1.413.588Q16 3.175 16 4v4.5l4-4v11l-4-4V16q0 .825-.587 1.413A1.93 1.93 0 0 1 14 18zm0-2h12V4H2z" /></g></g></svg>
))
